.group {
  display: inline-flex;
  width: fit-content;
  max-width: 100%;
  gap: var(--space-0-5);
  min-width: 0;
  margin: 0;
  padding: 3px;
  border: 0;
  border-radius: var(--radius-md);
  background: var(--color-surface-sunken);
}

.legend {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}

.segment {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-1-5);
  min-width: 0;
  height: calc(var(--control-md) - 6px);
  padding: 0 var(--space-3);
  border-radius: calc(var(--radius-md) - 3px);
  color: var(--color-text-muted);
  font-size: var(--text-sm);
  font-weight: var(--weight-medium);
  white-space: nowrap;
  cursor: pointer;
  user-select: none;
  transition:
    background-color var(--duration-fast) var(--ease-standard),
    color var(--duration-fast) var(--ease-standard);
}

.segment:hover {
  color: var(--color-text);
}

.segment:has(.radio:focus-visible) {
  outline: var(--focus-ring-width) solid var(--color-focus);
  outline-offset: 1px;
}

.selected {
  background: var(--color-surface-raised);
  color: var(--color-text);
  box-shadow: var(--shadow-sm);
}

.radio {
  position: absolute;
  inset: 0;
  margin: 0;
  opacity: 0;
  cursor: pointer;
}

.label {
  overflow: hidden;
  text-overflow: ellipsis;
}

.fullWidth {
  display: flex;
  width: 100%;
}

.fullWidth .segment {
  flex: 1;
}
